import { useLocation } from '@react-router';

// The lean international registry experience is served under /registry/intl/*.
// Component-level rendering decisions key off whether that route is active right
// now (which experience the couple is currently in), NOT off event-level
// eligibility — so an international-eligible couple viewing the US route
// (/registry/manage) gets the full US experience with none of the lean
// international components. Contrast with useInternationalRegistryExperience,
// which answers the event-level "is this account eligible?" question used for
// navigation/link targeting.
const INTERNATIONAL_REGISTRY_ROUTE_PATTERN = /\/registry\/intl(?:\/|$)/;

export const useIsInternationalRegistryRoute = (): boolean => {
  const { pathname } = useLocation();
  return INTERNATIONAL_REGISTRY_ROUTE_PATTERN.test(pathname);
};
